import TextFieldMui from 'src/components/TextFieldMui'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { Controller, UseFormRegister, Control } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import * as S from './TaxCouponItemFormUnit.styles'
import Suffix from '../Suffix'
import { ItemData } from 'src/features/tax-coupon/TaxCouponTypes'

dayjs.extend(utc)

interface ItemFormProps {
    entryDataIsComplete: boolean,
    control: Control<ItemData, any>,
    errors: any,
    register: UseFormRegister<ItemData>
    currencyFormatter: (formatted_value: any) => string
}

export default ({
  entryDataIsComplete, control, errors, register, currencyFormatter,
}: ItemFormProps) => (
  <S.ItemContainer>
    <Suffix suffix='UN'>
      <S.Input
        label='taxCoupon.boxQuantity'
        name='boxQuantity'
        id='boxQuantity'
        type='number'
        defaultValue={0}
        disabled={!entryDataIsComplete}
        inputProps={{
          ...register('boxQuantity',
            {
              required: 'Campo obrigatório',
              min: { value: 1, message: 'Deve ser um valor positivo' },
            }),
          'data-testid': 'boxQuantity-test',
        }}
        error={!!errors.boxQuantity}
        helperText={errors.boxQuantity?.message}
        autoComplete='off'
      />
    </Suffix>
    <S.Input
      label='taxCoupon.quantity'
      name='quantity'
      id='quantity'
      inputProps={{
        ...register('quantity',
          {
            required: 'Campo obrigatório',
            min: { value: 1, message: 'Deve ser um valor positivo' },
          }),
        'data-testid': 'quantity-test',
      }}
      error={!!errors.quantity}
      helperText={errors.quantity?.message}
      autoComplete='off'
      type='number'
      disabled={!entryDataIsComplete}
    />
    <Suffix suffix='UN'>
      <S.Input
        label='taxCoupon.single'
        name='single'
        id='single'
        defaultValue={0}
        inputProps={{
          ...register('single',
            {
              required: 'Campo obrigatório',
              min: { value: 0, message: 'O valor mínimo é 0' },
            }),
          'data-testid': 'single-test',
        }}
        error={!!errors.single}
        helperText={errors.single?.message}
        autoComplete='off'
        type='number'
        disabled={!entryDataIsComplete}
      />
    </Suffix>
    <Controller
      control={control}
      name='unitCost'
      rules={{ required: 'Campo obrigatório' }}
      render={({ field: { onChange, name, value } }) => (
        <NumberFormat
          customInput={TextFieldMui}
          style={S.NumberFormatStyles}
          thousandSeparator='.'
          decimalSeparator=','
          allowEmptyFormatting
          format={currencyFormatter}
          decimalScale={2}
          prefix='R$ '
          label='taxCoupon.unitCost'
          name={name}
          value={value}
          onChange={onChange}
          error={!!errors.unitCost}
          helperText={errors.unitCost?.message}
          disabled={!entryDataIsComplete}
          inputProps={{ 'data-testid': 'unitCost-test' }}
        />
      )}
    />
    <S.Input
      label='taxCoupon.expirationDate'
      name='expirationDate'
      id='expirationDate'
      type='date'
      inputProps={{
        ...register('expirationDate', {
          required: 'Campo obrigatório',
          validate: { atLeastToday: (v) => dayjs(v) >= dayjs() || 'Data anterior ou atual inválida' },
        }),
        'data-testid': 'expirationDate-test',
        min: dayjs().add(1, 'day').format('YYYY-MM-DD'),
      }}
      error={!!errors.expirationDate}
      helperText={errors.expirationDate?.message}
      InputLabelProps={{ shrink: true }}
      disabled={!entryDataIsComplete}
    />

    <S.ButtonSubmit
      disabled={!entryDataIsComplete}
      title='Adicionar'
      type='submit'
      bgColor='blue'
      hoverColor='darkBlueHover'
      letterColor='white'
    />
  </S.ItemContainer>
)
